import { useIntl } from '@/intl'
import { tokPx } from '@sunwebgroup/ui-components'
import { SearchField } from '@sunwebgroup/ui-components/uds'
import React from 'react'
import { styled } from 'styled-components'

const SearchFieldWrapper = styled.div`
  max-width: ${tokPx('primitives_area_size_480')};
`

export interface TableSearchProps {
  searchTerm: string
  onSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export function TableSearch({ searchTerm, onSearchChange }: TableSearchProps) {
  const intl = useIntl()

  return (
    <SearchFieldWrapper>
      <SearchField
        defaultValue={searchTerm}
        onChange={onSearchChange}
        placeholder={intl.formatMessage({ id: 'live-search_search_button_text' })}
        clearButtonAriaLabel={intl.formatMessage({ id: 'clear_search_button_aria_label' })}
      />
    </SearchFieldWrapper>
  )
}
